export const FETCH_MENU_START = 'FETCH_MENU_START';
export const FETCH_MENU_SUCCESS = 'FETCH_MENU_SUCCESS';
export const FETCH_MENU_FAILURE = 'FETCH_MENU_FAILURE';

export const CLEAR_MENU_START = 'CLEAR_MENU_START';

export const SET_LAST_SUBMENU = 'SET_LAST_SUBMENU'
